import { render, staticRenderFns } from "./NtsReportDetails.vue?vue&type=template&id=a3391262"
import script from "./NtsReportDetails.vue?vue&type=script&lang=js"
export * from "./NtsReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports